import * as types from './mutation-types'

export const fetchStakeholders = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/stakeholders`, { params }).then((response) => {
            commit(types.SET_STAKEHOLDERS, response.data.stakeholders.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addStakeholder = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/stakeholders', data).then((response) => {
            if (response.data.result == true) {
                commit(types.ADD_STAKEHOLDER, response.data)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateStakeholder = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/stakeholders/${data.id}`, data).then((response) => {
            if (response.data.result == true){
               commit(types.UPDATE_STAKEHOLDER, response.data)
            }
        resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}


export const fetchStakeholdersByUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/stakeholders/get-client-stakeholders`, data).then((response) => {
            commit(types.SET_STAKEHOLDERS, response.data.stakeholders)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const unsetStakeholders = ({ commit, dispatch, state }, data) => {
    commit(types.SET_STAKEHOLDERS, [])
}
